import { Routes, Route } from "react-router-dom";
import Products from "../components/products/Products";
import Shop from "../pages/shop";
import Landing from "../components/landing";
import ShoppingCard from "../components/card/ShoppingCard";
import Checkout from "../components/checkout/Checkout";
import Orders from "../components/orders/Orders";
import Profile from "../components/profile/Profile";
import Login from "../components/auth/Login";
import Register from "../components/auth/Register";


// import Service from "../pages/service/Service";
// import Blog from "../pages/blogs/Index";
import About from "../pages/about/About";

import ProductDetails from "../components/view/product/ProductDetails";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Products />} />
      <Route path="/shop" element={<Shop />} />
      <Route
        path="/shop/:productName/:productId"
        element={<ProductDetails />}
      />
    
      <Route path="/about" element={<About />} />
      <Route path="/cart" element={<ShoppingCard />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/orders" element={<Orders />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />





    </Routes>
  );
}

export default App;
